import { Injectable } from '@angular/core';

import { BroadcastService } from '../../core/services/broadcast.service';
import { ServiceManagerBase } from '../common/service-manager-base';
import { AiChatQueryModel, AiChatQueryResponseModel } from './ai.model';
import { AiApiService } from './ai-api.service';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class AiManagerService extends ServiceManagerBase
{
    constructor(private aiApiService: AiApiService,
                broadcastService: BroadcastService)
    {
        super(broadcastService);
    }

    clearCache()
    {
    }

    queryChat(model: AiChatQueryModel): Observable<AiChatQueryResponseModel>
    {
        return this.aiApiService.queryChat(model);
    }

    rateQuery(queryId: number, rating: number): Observable<any>
    {
        return this.aiApiService.rateQuery(queryId, rating);
    }
}
